/* eslint-disable */
// import {
//   Row,
//   Col,
//   Button,
//   Modal,
//   Breadcrumb,
//   Card,
//   Form,
// } from "react-bootstrap";
import DataTable from "react-data-table-component";
import React from "react";
import * as Icon from "react-bootstrap-icons";

import "./Contacts.css";

import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router";

//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import { addLeads } from "../../redux/actions/crmActions";
import Toast from "../assetLibComponents/shared/Toast";
import { ArrowRight } from "react-bootstrap-icons/dist";
//   import { addContact } from "../../../../../redux/actions/crmActions";

const AddLeads = (props) => {
  // const { pageFrom } = props;
  // const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [designation, setDesignation] = useState("");
  const [company, setCompany] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");

  // const contactDetails = useSelector((state) => state.crmLeads.contactDetails);

  // props.pageTypeHandler("CRM");

  const submitHandler = async (e) => {
    e.preventDefault();

    let newLead;

    newLead = {
      action: "add",
      name: fname,
      // lname: lname,
      company: company,
      company_website: companyWebsite,
      email: email,
      designation: designation,
      city: city,
      phone: phone,
    };

    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (email === "") {
      Toast("Please enter email", "E");
    } else if (regex.test(email) === false) {
      Toast("Please enter valid email", "E");
    } else if (companyWebsite === "") {
      Toast("Please enter company website", "E");
    } else if (!companyWebsite.includes(".")) {
      Toast("Please enter valid company website", "E");
    } else {
      dispatch(addLeads(props.authToken, newLead, onSuccess));
    }
  };
  
  const onSuccess = () => {
    navigate(-1);
  }

  // useEffect(() => {
  //   if (contactDetails) {
  //     setFname(contactDetails.fname);
  //     setLname(contactDetails.lname);
  //     if(contactDetails?.company?.comapny_name){
  //       setCompany(contactDetails?.company?.company_name);
  //     }else{
  //       setCompany(contactDetails?.company);
  //     }

  //     setCompanyWebsite(contactDetails.company_web);
  //     setEmail(contactDetails.email);
  //     setDesignation(contactDetails.designation);
  //     setCity(contactDetails.city);
  //     setPhone(contactDetails.phone);
  //   }
  // }, []);

  return (
    <>
      <div className="sub-header pt-[2rem]">
        <div className="">
          <div className="header-breadcrumb px-28 max-sm:px-4">
            <div
              className="mt-2 back-button show-pointer cursor-pointer my-auto flex"
              onClick={() => navigate(-1)}
            >
              <Icon.ChevronLeft
                style={{
                  fontSize: 25,
                  color: "#111",
                  padding: 5,
                  fontWeight: "bold",
                }}
              />

              <span className="ml-1 my-auto">Back</span>
            </div>
          </div>
        </div>
      </div>
      <div className="new-contact mt-4 px-10 max-sm:px-6">
        <div className="w-full px-20 max-sm:p-0">
          <div className="">
            <div>
              <div>
                <div>
                  <div className="mt-4 mb-4">
                    {/* <Form > */}
                    <div className="flex flex-col">
                      <div className="grid grid-cols-12">
                        <div className="col-span-5 max-sm:col-span-12">
                          <h6 className="mb-8 text-lg font-[600]">
                            Personal Information
                          </h6>
                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <div className="mt-1">
                                  Name
                                  {/* <span className="text-[red]">*</span> */}
                                </div>
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  autoComplete="off"
                                  required
                                  placeholder="Name"
                                  value={fname}
                                  onChange={(e) => {
                                    var regex = /[^a-zA-Z0-9\s]/g;
                                    if (!regex.test(e.target.value)) {
                                      setFname(e.target.value);
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {/* <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4">
                                <label className="mt-1">
                                  Last Name
                                </label>
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  //ref={nameRef}
                                  required
                                  placeholder="Last Name"
                                  value={lname}
                                  onChange={(e) => setLname(e.target.value)}
                                />
                              </div>
                            </div>
                          </div> */}

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Email</label>
                                <span className="text-[red]">*</span>
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="email"
                                  //ref={nameRef}
                                  required
                                  autoComplete="off"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Phone Number</label>
                                {/* <span className="text-[red]">*</span> */}
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="tel"
                                  //ref={nameRef}
                                  required
                                  autoComplete="off"
                                  placeholder="Phone Number"
                                  value={phone}
                                  onChange={(e) => {
                                    const integerRegex = /^\d+$/; // This regex matches one or more digits
                                    if ((integerRegex.test(e.target.value) || e.target.value === "") && e.target.value.length < 11) {
                                      setPhone(e.target.value)
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">City</label>
                                {/* <span className="text-[red]">*</span> */}
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  //ref={nameRef}
                                  autoComplete="off"
                                  placeholder="City"
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Designation</label>
                                {/* <span className="text-[red]">*</span> */}
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  //ref={nameRef}
                                  autoComplete="off"
                                  placeholder="Designation"
                                  value={designation}
                                  onChange={(e) =>
                                    setDesignation(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-2"></div>

                        <div className="col-span-5 max-sm:col-span-12">
                          <h6 className="mb-8 max-sm:mt-8 text-lg font-[600]">
                            Company Information
                          </h6>
                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Company Name</label>
                                {/* <span className="text-[red]">*</span> */}
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  //ref={nameRef}
                                  autoComplete="off"
                                  placeholder="Company Name"
                                  value={company}
                                  onChange={(e) => setCompany(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Company<span className="text-[red] sm:hidden">*</span> Website</label>
                                <span className="text-[red] max-sm:hidden">*</span>
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  //ref={nameRef}
                                  autoComplete="off"
                                  placeholder="Company Website"
                                  value={companyWebsite}
                                  onChange={(e) =>
                                    setCompanyWebsite(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        onClick={submitHandler}
                        type="button"
                        className="ml-auto mt-10 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                      >
                        Submit
                        <ArrowRight
                          className="-ml-0.5 h-5 w-5"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLeads;
